module.exports = __webpack_public_path__ + "img/arrow_right_green.d0e0338e.svg";